/* eslint-disable */
// CommonJS on purpose: this module is imported by the React app (webpack) AND
// required by the Node build scripts (sitemap + prerendered head tags), so the
// URLs, titles and structured data can never drift between runtime and build.

const SITE_URL = 'https://www.tabiagroup.com';
const ORG_NAME = 'Tabia Group';

const memberUrl = (slug) => `${SITE_URL}/equipo/${slug}`;

const memberTitle = (m) => `${m.name}, ${m.title} | ${ORG_NAME}`;

const memberDescription = (m) => m.metaDesc;

// schema.org Person. `image` is deliberately omitted when we only have an
// initials placeholder — we don't claim a likeness we don't have.
function personJsonLd(m) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: m.name,
    jobTitle: m.title,
    description: m.metaDesc,
    url: memberUrl(m.slug),
    worksFor: {
      '@type': 'Organization',
      name: ORG_NAME,
      url: SITE_URL
    }
  };

  if (!m.pendingPhoto) {
    data.image = `${SITE_URL}/${m.image}`;
  }

  return data;
}

function breadcrumbJsonLd(m) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: 'Equipo', item: `${SITE_URL}/equipo` },
      { '@type': 'ListItem', position: 3, name: m.name, item: memberUrl(m.slug) }
    ]
  };
}

module.exports = {
  SITE_URL,
  ORG_NAME,
  memberUrl,
  memberTitle,
  memberDescription,
  personJsonLd,
  breadcrumbJsonLd
};
